import { Options, Vue } from 'vue-class-component';
import {
  IRoomObjectDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'FieldsShutter',
  props: {
    roomObject: {
      type: Object as PropType<IRoomObjectDTO>,
      required: true,
    },
  },
})
export default class FieldsShutter extends Vue {
  roomObject!: IRoomObjectDTO;
}
